import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'
import { connect } from 'react-redux';
import slug from 'slug';
import { fetchMenu } from '../../redux/actions';
import RenderProduct from '../RenderProduct';
import RenderCategory from '../RenderCategory';
import get from 'lodash/get';

import './ContentBlocks.css'
class ContentBlock extends Component {
  render() {

    const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }

    const { categories, products } = { ...this.props };

    const productGroups = categories.filter(category => isItemValid(category, this.props.date));

    const props = this.props;

    return (
      <div id={slug(props.fields.heading.toLowerCase())} className={`content-block ${props.align.toLowerCase()}`}>
        {props.fields.topHeading && <div className="subheading">{props.fields.topHeading}</div>}
        {(props.fields.heading && props.align.toLowerCase()==='center') && <h2>{props.fields.heading}</h2>}
        {(props.fields.heading && props.align.toLowerCase()!=='center') && <h3>{props.fields.heading}</h3>}

        {props.fields.lead && <div className="lead">
          <ReactMarkdown source={props.fields.lead} softBreak="br" />
        </div>}

        {props.fields.content && <div className="content">
          <ReactMarkdown source={props.fields.content} softBreak="br" />
        </div>}

        {props.fields.image && <img className="content-image" src={get(props, 'fields.image') ? `${get(props, 'fields.image[0].fields.file.url')}?fm=jpg&q=80`:null} alt="" />}

        {(props.fields.leadLinkText && (props.fields.leadInternalLink || props.fields.leadLinkUrl)) && <a href={props.fields.leadInternalLink ? props.fields.leadInternalLink.fields.slug : props.fields.leadLinkUrl} className="btn">{props.fields.leadLinkText}</a>}

        {props.fields.elements && props.fields.elements.map((child, index) => {
          if (child.sys.contentType.sys.id === 'category' || child.sys.contentType.sys.id === 'product') {
            let product = products.find((p) => {
              return p.sys.id === child.sys.id
            })
            let category = productGroups.find((p) => {
              return p.sys.id === child.sys.id
            })

            if (product) {
              return (
                <RenderProduct product={product} key={product.fields.title} {...this.props} />
              )
            }

            if (category) {
              return (
                <RenderCategory category={category} key={category.fields.title} {...this.props} />
              )
            }
          }
          
          if (child.sys.contentType.sys.id === 'container') {
            return(
              <div id={slug(child.fields.heading.toLowerCase())} className={`content-block ${(child.fields.align ? child.fields.align.toLowerCase() : '')}`} key={child.sys.id}>
                {(child.fields.heading) && <h2>{child.fields.heading}</h2>}

                {child.fields.lead && <div className="lead">
                  <ReactMarkdown source={child.fields.lead} softBreak="br" />
                </div>}

                {child.fields.content && <div className="content">
                  <ReactMarkdown source={child.fields.content} softBreak="br" />
                </div>}

                {(child.fields.leadLinkText && (child.fields.leadInternalLink || child.fields.leadLinkUrl)) && <a href={child.fields.leadInternalLink ? child.fields.leadInternalLink.fields.slug : child.fields.leadLinkUrl} className="btn">{child.fields.leadLinkText}</a>}
              </div>
            )
          }

          return null;
        })}
      </div>
    )
  }
}

ContentBlock.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  date: state.date,
  menus: state.menus,
  products: state.products,
  categories: state.categories
});

const mapDispatchToProps = {
  fetchMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ContentBlock));



// WEBPACK FOOTER //
// ./src/components/ContentBlocks/ContentBlock.js